// extracted by mini-css-extract-plugin
export var container = "_oo-0";
export var dotAnimation = "_oo-2";
export var dotsLoading = "_oo-1";